module.exports = __webpack_public_path__ + "img/logo.45c2458e.webp";